export const templateConfigs = {
  1: {
    name: "Classic Professional",
    description: "Traditional blue theme",
    primaryColor: "#2b6cb0",
    secondaryColor: "#3182ce",
    accentBg: "#ebf4ff",
    fontFamily: "'Inter', Arial, sans-serif",
    headerAlign: "center",
    sectionBorderStyle: "2px solid #2b6cb0",
    skillBadgeBg: "#ebf4ff",
    skillBadgeColor: "#1a365d",
    nameColor: "#000",
    titleColor: "#000",
    skillsLayout: "grid",
    skillBorderRadius: "4px",
    skillPadding: "6px 10px",
  },
  2: {
    name: "Modern Executive",
    description: "Elegant dark theme",
    primaryColor: "#1a202c",
    secondaryColor: "#2d3748",
    accentBg: "#edf2f7",
    fontFamily: "'Georgia', serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    sectionUnderline: "3px solid #1a202c",
    skillBadgeBg: "transparent",
    skillBadgeColor: "#1a202c",
    skillBorder: "1px solid #cbd5e0",
    nameColor: "#1a202c",
    titleColor: "#2d3748",
    skillsLayout: "flex",
    skillGap: "16px 10px",
    skillBorderRadius: "20px",
    skillPadding: "8px 16px",
  },
  3: {
    name: "Creative Gradient",
    description: "Vibrant modern two-column gradient layout",
    primaryColor: "#ff5f9e",
    secondaryColor: "#7c3aed",
    accentBg: "linear-gradient(180deg, #fff6fb 0%, #f6f3ff 100%)",
    fontFamily: "'Poppins', 'Segoe UI', sans-serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    sectionGradient: "linear-gradient(90deg, #ff5f9e 0%, #7c3aed 100%)",
    sectionBgGradient:
      "linear-gradient(180deg, rgba(255,95,158,0.06), rgba(124,58,237,0.04))",
    skillBadgeBg: "linear-gradient(135deg, #ffd7ec 0%, #d7c9ff 100%)",
    skillBadgeColor: "#3b0b3b",
    nameColor: "#0f172a",
    titleColor: "#374151",
    titleBg: "transparent",
    skillsLayout: "flex",
    skillBorderRadius: "18px",
    skillPadding: "6px 14px",
    skillShadow: "0 6px 18px rgba(124,58,237,0.12)",
    layout: "two-column",
    sidebarWidth: "36%",
    sidebarBg: "linear-gradient(180deg, #fff6fb 0%, #f3f0ff 100%)",
    sidebarTextColor: "#2b0b2b",
    sidebarAccent: "linear-gradient(135deg, #ff5f9e 0%, #7c3aed 100%)",
  },
  4: {
    name: "Minimalist Tech",
    description: "Side-border minimalist with horizontal sections",
    primaryColor: "#6366f1",
    secondaryColor: "#818cf8",
    accentBg: "#eef2ff",
    fontFamily: "'Inter', -apple-system, sans-serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    skillBadgeBg: "transparent",
    skillBadgeColor: "#4338ca",
    skillBorder: "1.5px solid #c7d2fe",
    nameColor: "#111827",
    titleColor: "#6b7280",
    skillsLayout: "inline",
    skillBorderRadius: "16px",
    skillPadding: "5px 12px",
    layout: "side-border",
    leftBorderWidth: "6px",
    leftBorderColor: "#6366f1",
    sectionLayout: "horizontal",
    sectionBgColor: "#f9fafb",
    experienceLayout: "compact",
  },
  5: {
    name: "Aurora Glass",
    description: "Glassmorphism cards with blue–purple gradient",
    primaryColor: "#0ea5e9",
    secondaryColor: "#a78bfa",
    accentColor: "#22d3ee",
    accentBg:
      "linear-gradient(135deg, rgba(14,165,233,0.10), rgba(167,139,250,0.10))",
    fontFamily: "'Nunito Sans', 'Inter', 'Arial', sans-serif",
    headerAlign: "center",
    sectionBorderStyle: "none",
    skillBadgeBg:
      "linear-gradient(135deg, rgba(14,165,233,0.25), rgba(167,139,250,0.25))",
    skillBadgeColor: "#0f172a",
    skillBorder: "1px solid rgba(148, 163, 184, 0.35)",
    nameColor: "#0f172a",
    titleColor: "#0ea5e9",
    skillsLayout: "flex",
    skillBorderRadius: "24px",
    skillPadding: "8px 18px",
    skillGap: "12px 10px",
    layout: "timeline",
    timelineColor: "rgba(14, 165, 233, 0.35)",
    timelineDotSize: "10px",
    sectionIconBg: "linear-gradient(135deg, #0ea5e9 0%, #a78bfa 100%)",
    sectionIconColor: "#0f172a",
    cardBg: "rgba(255, 255, 255, 0.65)",
    cardBorder: "1px solid rgba(148, 163, 184, 0.30)",
    cardShadow: "0 10px 30px rgba(2, 6, 23, 0.15)",
  },
  6: {
    name: "Professional Column",
    description: "Clean column-divided layout with subtle accents",
    primaryColor: "#1e3a8a",
    secondaryColor: "#3b82f6",
    accentColor: "#1e40af",
    accentBg: "#eff6ff",
    fontFamily: "'Lato', 'Segoe UI', sans-serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    skillBadgeBg: "#f0f9ff",
    skillBadgeColor: "#1e3a8a",
    skillBorder: "1px solid #bfdbfe",
    nameColor: "#1e3a8a",
    titleColor: "#64748b",
    skillsLayout: "grid",
    skillBorderRadius: "4px",
    skillPadding: "6px 12px",
    layout: "professional-column",
    leftColumnWidth: "30%",
    leftColumnBg: "#f8fafc",
    sectionTitleBg: "#1e3a8a",
    sectionTitleColor: "#ffffff",
    dividerColor: "#cbd5e1",
  },
  7: {
    name: "Minimalist Card",
    description: "Clean card-based layout with purple accents",
    primaryColor: "#7c3aed",
    secondaryColor: "#8b5cf6",
    accentColor: "#6d28d9",
    accentBg: "#faf5ff",
    fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
    headerAlign: "center",
    sectionBorderStyle: "none",
    skillBadgeBg: "#f3e8ff",
    skillBadgeColor: "#5b21b6",
    skillBorder: "1px solid #e9d5ff",
    nameColor: "#1f2937",
    titleColor: "#7c3aed",
    skillsLayout: "flex",
    skillBorderRadius: "12px",
    skillPadding: "7px 15px",
    skillGap: "10px 8px",
    layout: "card-minimal",
    cardBg: "#ffffff",
    cardShadow: "0 4px 12px rgba(124, 58, 237, 0.08)",
    cardBorder: "1px solid #f3e8ff",
    cardRadius: "12px",
    sectionSpacing: "20px",
    headerBorder: "3px solid #7c3aed",
  },
  8: {
    name: "Elegant Serif",
    description: "Classic serif typography with burgundy tones",
    primaryColor: "#881337",
    secondaryColor: "#9f1239",
    accentColor: "#be123c",
    accentBg: "#fff1f2",
    fontFamily: "'Playfair Display', 'Georgia', serif",
    headerAlign: "center",
    sectionBorderStyle: "none",
    sectionUnderline: "2px solid #881337",
    skillBadgeBg: "transparent",
    skillBadgeColor: "#881337",
    skillBorder: "1.5px solid #fda4af",
    nameColor: "#881337",
    titleColor: "#64748b",
    skillsLayout: "inline",
    skillBorderRadius: "25px",
    skillPadding: "6px 16px",
    layout: "classic-serif",
    headerDecoration: "ornamental",
    sectionSpacing: "28px",
    textAlign: "justify",
    lineHeight: "1.7",
  },
  9: {
    name: "Tech Stack",
    description: "Developer-focused monospace design with terminal aesthetics",
    primaryColor: "#16a34a",
    secondaryColor: "#22c55e",
    accentColor: "#15803d",
    accentBg: "#f0fdf4",
    fontFamily: "'JetBrains Mono', 'Courier New', monospace",
    headerAlign: "left",
    sectionBorderStyle: "2px dashed #86efac",
    skillBadgeBg: "#052e16",
    skillBadgeColor: "#86efac",
    skillBorder: "1px solid #16a34a",
    nameColor: "#052e16",
    titleColor: "#16a34a",
    skillsLayout: "flex",
    skillBorderRadius: "2px",
    skillPadding: "5px 12px",
    skillGap: "8px 6px",
    layout: "terminal",
    terminalBg: "#0a0a0a",
    terminalText: "#86efac",
    codeBlock: true,
    headerPrefix: ">",
    bulletStyle: "$",
  },
  10: {
    name: "Corporate Modern",
    description: "Professional navy and gold layout with structured sections",
    primaryColor: "#1e293b",
    secondaryColor: "#334155",
    accentColor: "#d97706",
    accentBg: "#fef3c7",
    fontFamily: "'Open Sans', 'Helvetica', sans-serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    sectionAccentBar: "4px solid #d97706",
    skillBadgeBg: "#f8fafc",
    skillBadgeColor: "#1e293b",
    skillBorder: "1px solid #cbd5e1",
    nameColor: "#1e293b",
    titleColor: "#d97706",
    skillsLayout: "grid",
    skillBorderRadius: "6px",
    skillPadding: "7px 14px",
    layout: "corporate-structured",
    headerBorderBottom: "3px solid #d97706",
    sectionBg: "#ffffff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    gridColumns: "repeat(3, 1fr)",
  },
  13: {
    name: "Fresher Pop",
    description: "Playful pastel layout for fresh graduates",
    primaryColor: "#06b6d4",
    secondaryColor: "#f472b6",
    accentBg:
      "linear-gradient(90deg, rgba(6,182,212,0.06), rgba(244,114,182,0.06))",
    fontFamily: "'Nunito', 'Inter', sans-serif",
    headerAlign: "center",
    sectionBorderStyle: "none",
    sectionTitleBg: "#06b6d4",
    sectionTitleColor: "#ffffff",
    skillBadgeBg: "#fff0f6",
    skillBadgeColor: "#7c2d5e",
    nameColor: "#0f172a",
    titleColor: "#f472b6",
    skillsLayout: "flex",
    skillBorderRadius: "12px",
    skillPadding: "6px 12px",
    layout: "fresher-pop",
    cardBg: "#fff",
    cardShadow: "0 8px 24px rgba(6,182,212,0.06)",
    headerDecoration: "rounded",
  },
  14: {
    name: "Fresher Neo",
    description:
      "Bold neo-minimal layout with vibrant left accent for new grads",
    primaryColor: "#06b6d4",
    secondaryColor: "#84cc16",
    accentBg:
      "linear-gradient(90deg, rgba(6,182,212,0.06), rgba(132,204,22,0.06))",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    headerAlign: "left",
    sectionBorderStyle: "none",
    nameColor: "#0f172a",
    titleColor: "#06b6d4",
    skillBadgeBg: "#f0fdfa",
    skillBadgeColor: "#065f46",
    skillsLayout: "flex",
    skillBorderRadius: "10px",
    skillPadding: "6px 12px",
    layout: "fresher-neo",
    leftAccentWidth: "8px",
    leftAccentColor: "linear-gradient(180deg,#06b6d4,#84cc16)",
    cardBg: "#ffffff",
    cardShadow: "0 8px 28px rgba(6,182,212,0.04)",
    headerDecoration: "accent-strip",
  },
};

export const getTemplateStyles = (templateId = 1) => {
  return templateConfigs[templateId] || templateConfigs[1];
};
